var map = {
	"./screenshots/coindash.png": 3274,
	"./screenshots/demo.jpg": 3275,
	"./screenshots/devtools.png": 3276,
	"./screenshots/enigma.png": 3277,
	"./screenshots/etherparty.png": 3278,
	"./screenshots/extension.png": 3279,
	"./screenshots/fake.png": 3280,
	"./screenshots/graphql.png": 3281,
	"./screenshots/lockdown.png": 3282
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3306;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/screenshots\/[^\/]+\.(jpg|jepg|png)$
// module id = 3306
// module chunks = 0